'use client'

import { Container } from '@/components/container'
import { Heading, Subheading } from '@/components/text'
import { MotionDiv } from '@/components/motion-wrapper'
import Image from 'next/image'

export function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <Container>
        <MotionDiv
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
        >
          <div>
            <Subheading>Our Story</Subheading>
            <Heading as="h2" className="mt-2">
              Building Tomorrow's Products Today
            </Heading>
            <p className="mt-6 text-lg text-gray-600 leading-relaxed">
              Saisha Consultancy is a product-focused engineering studio founded with a simple mission: help founders 
              and companies turn ideas into real, high-performance digital products. What began as a solo effort has 
              grown into a team of four skilled engineers, and together we've successfully delivered 10+ long-term, 
              end-to-end projects across diverse industries.
            </p>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              We specialize in building AI-powered, scalable SaaS platforms and MVPs that ship fast, perform flawlessly, 
              and evolve smoothly. For the past 2.5 years, we've led technical direction—architecting systems, crafting 
              high-performance front-end experiences, and guiding clients from concept to fully functional production builds.
            </p>
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              We build AI-first, high-performance UIs and scalable SaaS systems integrating analytics, billing, security, 
              and advanced user experiences. Whether you're launching an MVP or scaling a production platform, we bring 
              clarity, speed, and engineering excellence to your product journey. Our expertise spans React, TypeScript, 
              Next.js, full-stack development, and cutting-edge AI integration.
            </p>
          </div>
          <div className="relative pl-10 hidden lg:block">
            <MotionDiv
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Image 
                src="/assets/ms.png" 
                alt="Saisha Consultancy" 
                width={400} 
                height={400} 
                className="rounded-2xl shadow-lg" 
              />
            </MotionDiv>
          </div>
        </MotionDiv>
      </Container>
    </section>
  )
}

